// extracted by mini-css-extract-plugin
export default {"tableSection":"probation-review-page_tableSection__ye9zR","iconBtn":"probation-review-page_iconBtn__VMb8F"};